function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #959595;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "empleo",
  transform: "translate(-376.493 -395.735)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Trazado_78",
  "data-name": "Trazado 78",
  className: "cls-1",
  d: "M404.917,400.841h-6.8V398.1a2.369,2.369,0,0,0-2.366-2.366h-6.943a2.368,2.368,0,0,0-2.366,2.366v2.74h-6.8a3.145,3.145,0,0,0-3.142,3.141c0,1.574-.161,2.987,1.031,4.576a5.117,5.117,0,0,0,2.681,1.855l10.481,3.051a5.657,5.657,0,0,0,3.172,0l10.481-3.051a5.117,5.117,0,0,0,2.681-1.855c1.2-1.6,1.031-3.024,1.031-4.576a3.145,3.145,0,0,0-3.141-3.141Zm-16.471-2.74a.362.362,0,0,1,.362-.362h6.943a.363.363,0,0,1,.362.362v2.74h-7.667Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trazado_79",
  "data-name": "Trazado 79",
  className: "cls-1",
  d: "M404.906,412.337c-11.3,3.292-11.158,3.358-12.627,3.358s-1.112-.005-12.627-3.358a7.1,7.1,0,0,1-3.152-1.9v9.617a3.145,3.145,0,0,0,3.142,3.141h25.275a3.145,3.145,0,0,0,3.141-3.141v-9.617a7.09,7.09,0,0,1-3.152,1.9Z"
}));

function SvgEmpleo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.573,
    height: 27.457,
    viewBox: "0 0 31.573 27.457",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpleo);
export default __webpack_public_path__ + "static/media/empleo.0ef92470.svg";
export { ForwardRef as ReactComponent };